<script setup lang="ts">
import { onMounted, watch } from 'vue'

import EmbedContentLoader from './EmbedContentLoader.vue'
interface CustomWindow {
  instgrm?: { Embeds: { process: () => void } };
}

declare let window: CustomWindow

const props = defineProps({
  html: {
    type: String,
    required: true
  }
})

const triggerEmbedScript = () => {
  if (typeof window !== 'undefined' && window.instgrm !== undefined) {
    window.instgrm.Embeds.process()
  }
}

onMounted(() => {
  triggerEmbedScript()
})

watch(() => props.html, () => {
  triggerEmbedScript()
})
</script>

<template>
  <EmbedContentLoader :html="props.html"
                      @script-loaded="triggerEmbedScript()" />
</template>
